// @ts-check
"use strict";

const EXCLUDED_FLAVOURS = new Set([
  "senior-b2c-playstore",
  "senior-family-b2c",
  "senior-mdapp_b2c",
  "senior-mdapp_b2b",
  "senior-caregiver",
  "b2c-playstore",
  "family-b2c",
  "mdapp_b2c",
  "mdapp_b2b",
  "caregiver",
]);

/** @param {string} flavour */
const isRelevantFlavour = flavour => !EXCLUDED_FLAVOURS.has(flavour);

/**
 * @param {string} appId
 * @returns {string}
 */
const deriveFlavourFromAppId = appId => {
  if (appId.includes("family")) return "family";
  if (appId.includes("korian")) return "senior-korian";
  if (appId.includes("games")) return "senior-games";
  if (appId.includes("mdapp")) return appId.includes("b2c") ? "senior-mdapp_b2c" : "senior-mdapp_b2b";
  if (appId.includes("caregiver")) return "senior-caregiver";
  if (appId.includes("b2clicswonly")) return "senior-b2c-playstore";
  if (appId.includes("b2clic")) return "senior-b2c";
  if (appId.includes("b2b")) return "senior-b2b";
  if (appId.includes("dementia") || appId.includes("senior")) return "senior-b2b";
  return "unknown";
};

/** @param {string} appId */
const isRelevantAppId = appId => {
  const id = appId.trim();
  if (id === "" || id.toLowerCase() === "unknown") return false;
  return isRelevantFlavour(deriveFlavourFromAppId(id));
};

module.exports = {
  isRelevantFlavour,
  deriveFlavourFromAppId,
  isRelevantAppId,
};
